import { Grid, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const PlanDetailsStep = ({ state, errors, dispatch }) => {
    const { t } = useTranslation();

    const updateField = (field) => (event) => {
        dispatch({ type: 'setField', field, value: event.target.value });
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Typography variant="h5" gutterBottom>
                    {t('nutrition.editor.planDetailsTitle')}
                </Typography>
                <Typography color="text.secondary">
                    {t('nutrition.editor.planDetailsHelp')}
                </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
                <TextField
                    fullWidth
                    autoFocus
                    label={t('nutrition.titleLabel')}
                    value={state.title}
                    onChange={updateField('title')}
                    error={Boolean(errors.title)}
                    helperText={errors.title ? t(errors.title) : ' '}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={t('nutrition.durationLabel')}
                    type="number"
                    value={state.durationDays}
                    onChange={updateField('durationDays')}
                    error={Boolean(errors.durationDays)}
                    helperText={
                        errors.durationDays
                            ? t(errors.durationDays)
                            : t('nutrition.editor.durationHelp')
                    }
                    inputProps={{ min: 1, max: 365 }}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    label={t('nutrition.descritionLabel')}
                    value={state.description}
                    onChange={updateField('description')}
                    error={Boolean(errors.description)}
                    helperText={errors.description ? t(errors.description) : ' '}
                />
            </Grid>
        </Grid>
    );
};

PlanDetailsStep.propTypes = {
    state: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
};

export default PlanDetailsStep;
